import { CalendarTodayOutlined } from '@material-ui/icons';
import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  max-width: 350px;
  border: 1px solid #454a67;
  box-shadow: rgba(0, 0, 0, 0.5) 4px 4px 4px;
  width: 100%;
`;

export const ModalHeader = styled.div`
  gap: 12px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 5px;
`;

export const ModalHeaderIcon = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  border-bottom: 1px solid #5062f0;
  width: 100%;
  padding: 17px 17px 18px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  color: #5062f0;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 3px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  line-height: 1;
`;

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  max-height: 400px;
  overflow-y: auto;
  /* padding: 17px 18px; */
`;

export const FormRow = styled.div`
  display: flex;
  gap: 15px;
  border-bottom: 1px solid #d0d3e2;
  padding-left: 15px;
  padding-right: ${(props) => (props.isOperation ? '10px' : '20px')};
  padding-bottom: 15px;
  padding-top: 6px;

  &:last-child {
    border-bottom: none;
  }
`;

export const FormLabel = styled.label`
  font-size: 12px;
  font-weight: bold;
  color: #010311;
  width: 65px;
`;

export const TimeInput = styled.input`
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  width: 100px;
  text-align: center;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  width: 100%;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #313347;
`;

export const Time = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    font-size: 12px;
    font-weight: 700;
  }
`;

export const TimeInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TimeInputWithIcon = styled.input.attrs({ type: 'time' })`
  font-size: 12px;
  width: 100px;
  text-align: center;
  border: none;
  border-bottom: 1px solid #77798b;
  padding-left: 16px;
  padding-bottom: 4px;
  width: 75px;

  &::-webkit-calendar-picker-indicator {
    opacity: 0;
    width: 16px;
    height: 16px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const TimeInputIcon = styled(CalendarTodayOutlined)`
  position: absolute;
  left: 4px;
  color: #313347;
  font-size: 16px;
  margin-bottom: 4px;
  cursor: pointer;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 20px 0px;
  gap: 12px;
`;
